export default function(tag, attr, text) {
  var el = document.createElement(tag);
  for (var key in attr) el.setAttribute(key, attr[key]);
  if (text != null) el.textContent = text;
  return el;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-view/src/element.js
// module id = 345
// module chunks = 0